import { endPoint } from "./base.config";

export const companyBankService = {
  buyRemittance: `${endPoint}companyBankServices/buyRemittance`,
  addUpdate: `${endPoint}companyBankServices/add-update`,
}